
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.571 6.286H2.43c-.632 0-1.143.511-1.143 1.143v6.857c0 .63.511 1.143 1.143 1.143h9.142c.632 0 1.143-.512 1.143-1.143V7.429c0-.632-.511-1.143-1.143-1.143zM11 6.286V4.57a4 4 0 10-8 0v1.715","stroke":"#000C1F","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M7 11.429a.571.571 0 100-1.143.571.571 0 000 1.143z","stroke":"#000C1F","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    